<template>
    <div>
        <div class="list-collapsible">
            <q-collapsible 
                id="collapsible-items"
                collapse-icon="fa icon-chevron-down"
                v-for="(item,index) in contentItems" 
                :key="index"
                :class="highlightRow(item) ? 'warning' : ''"
            >
                <template slot="header">
                    <div class="column full-width">
                        <q-item-main
                            :label=castLabel(item[label])
                        />
                        <q-item-main
                            class="no-margin"
                            :sublabel="item[subLabel] ? translateDate(item[subLabel]) : ''"
                        />
                    </div>
                    <q-item-side right v-if="highlightRow(item)">
                        <q-btn
                            round
                            flat
                            size="sm"
                            class="q-ml-sm"
                            icon="fa icon-warning"
                            @click.native="orderWarningButton"
                        >
                            <q-popover id="warning-pop">
                                <div class="group text-center warning-text">
                                    <p>{{ $T('This lending expired')}} <strong style="color: #E3813B;">{{ calculateLendingExpiredDays(item) }}</strong>.</p>
                                    <p>{{ $T('The kit returned and you want close the order?')}}</p>
                                    <div class="row justify-center">
                                        <router-link tag="a" to="orders/in-lending">
                                            {{ $T('Go to close lending') }}
                                            <q-icon class="q-ml-sm" name="fa icon-chevron-secondary-right"></q-icon>
                                        </router-link>
                                    </div>
                                </div>
                            </q-popover>
                        </q-btn>
                    </q-item-side>
                </template>
                <div class="column">
                    <div v-for="(column,index) in columnsToShow" :key="index" :ref="`${index}`" class="row justify-between items-center default-height border-content">
                        <span :class="index === 0 ? 'text-weight-bold' : ''" class="font-label text-right col-4" :style="index === 0  && highlightRow(item) ? 'color:#e3813b !important;' : ''">{{ column.label }}</span>
                        <span :class="index === 0 && highlightRow(item) ? 'col-5 warning' : 'col-7'" class="font-mobile-collapse" :style="styleForValues(index, item)">{{ index === 0 && column.hasOwnProperty('type') && column.type === 'date' ? translateDate(item[column.name]) : item[column.name]}}</span>
                        <q-icon v-if="index === 0 && highlightRow(item)" name="fa icon-edit-mobile" class="col-1" @click.native="edit(item)"></q-icon>
                    </div>
                    <div v-if="showActionContent">
                        <hr class="styled-hr" />
                        <div class="row justify-center q-mt-md q-mb-sm">
                            <v-button 
                                rounded
                                :label="labelBtnCollapsible()"
                                color="primary"
                                class="no-shadow capitalize btn-collapsible"
                                @click="openModal(item)"
                            />
                        </div>
                    </div>
                </div>
            </q-collapsible>
        </div>
        <hr class="styled-hr" />
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'Collapsible',

    props: {
        contentItems: {
            type: Array,
            required: true
        },
        columnsCollapsible:{
            type: Array,
            required: true
        },
        visibleColumns: {
            type: Array
        },
        label: {
            type: [String, Number]
        },
        subLabel: {
            type: [String, Number]
        },
    },

    updated(){
        if(this.contentItems && this.columnsCollapsible && this.$q.screen.lt.sm){
            this.$nextTick(() => {
                let refsArray = Object.values(this.$refs).filter(item => item.length)
                let indexLastElement = refsArray.length - 1
                refsArray.forEach((item,index) => {
                    if(index === indexLastElement){
                        for (let i = 0; i < refsArray[indexLastElement].length; i++) {
                            item[i].classList.add('no-border')
                        }
                    }
                    if(index === 0){
                        for (let i = 0; i < refsArray[0].length; i++) {
                            item[i].classList.add('border-title')
                        }
                    }
                })
            })
        }
    },

    methods:{
        orderWarningButton(event) {
            event.stopPropagation()
        },

        calculateLendingExpiredDays(item) {
            let days = Math.abs(moment(item.end_lending_at, 'YYYY-MM-DD HH:mm:ss').diff(moment().format('YYYY-MM-DD HH:mm:ss'), 'days'))
            return 'hace ' + days + (days === 1 ? ' día' : ' días')
        },

        edit(item){
            this.$emit('collapsibleRowEdit', item)
        },

        openModal(item){
            this.$emit('isModalOpen', {openModal: true, contentItem: item, columnsCollapsible: this.columnsCollapsible})
        },

        highlightRow(item) {
            return (this.$route.name === 'lending-point.orders' || this.$route.name === 'sales-expert.orders') &&
                item['order_status.description'] === window.config.orderStatuses['IN_LENDING'] &&
                item.end_lending_at &&
                moment(item.end_lending_at, 'YYYY-MM-DD HH:mm:ss').isBefore(moment().format('YYYY-MM-DD HH:mm:ss'))
        },

        styleForValues(index, item) {
            let style = ''
            if (index === 0) {
                style += 'font-weight:bold;'
            }
            if (this.highlightRow(item)) {
                style += 'color: #E3813B!important;'
            }
            return style
        },

        translateDate(date) {
            return moment(date).format('DD-MM-YYYY')
        },

        castLabel(value) {
            return value.toString()
        },

        isOrdersLendingRoute() {
          return this.$route.name === 'sales-expert.orders.in-lending' || this.$route.name === 'lending-point.orders.in-lending'
        },

        labelBtnCollapsible() {
            return this.isOrdersLendingRoute() ? this.$T('close lending') : this.$T('confirm delivery')
        },

        showActionContent() {
            return this.isOrdersLendingRoute() ||
                this.$route.name === 'sales-expert.orders.delivery' ||
                this.$route.name === 'lending-point.lending-kits.pending-reception'
        }
    },

    computed: {
        columnsToShow() {
            let columnsFromDefault = this.columnsCollapsible.filter( column => {
                return column.required === true && column.name !== '-actions'
            })

            if (this.visibleColumns) {
                this.visibleColumns.forEach(preferenceColumn => {
                    let col = this.columnsCollapsible.find(column => {
                        return column.name === preferenceColumn && !column.required
                    })
                    if (col) {
                        columnsFromDefault.push(col)
                    }
                })
            }
            return columnsFromDefault
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Collapsible.vue